import {
  footerLink,
  officeAddress,
  socialMedia,
} from "../constants/Footer.tsx";
import { Link } from "react-router-dom";
import Image from "../shared/image/Image.tsx";
import logo from "../assets/logo.png";
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bottom-0 w-screen border-t border-gray-800 bg-gray-950 pb-4 pt-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-6">
          {/* Brand Section */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <Link to="/" className="mb-4 inline-block">
              <Image
                src={logo}
                className="h-full max-h-9 max-w-full shrink-0 object-contain lg:max-h-10"
                alt="Babblebots.AI Logo"
              />
            </Link>
            <p className="font-manrope mb-6 text-sm text-gray-400 lg:max-w-xs">
              AI-powered recruitment platform that makes hiring faster, fairer,
              and more effective. Transform your talent acquisition with
              intelligent automation.
            </p>

            {/* Social Media */}
            <div className="flex gap-3">
              {socialMedia.map((link, i) => {
                const Component = link.icon;
                return (
                  <a
                    key={i}
                    href={link.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-800 bg-gray-900 text-gray-400 transition-all hover:border-teal-500 hover:bg-teal-500/10 hover:text-teal-400"
                    aria-label={link.label}
                  >
                    <Component size={20} weight="fill" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Footer Links */}
          {footerLink.map((section) => (
            <div key={section.title} className="flex flex-col gap-3">
              <h3 className="font-satoshi text-sm font-bold text-gray-100">
                {section.title}
              </h3>
              <ul className="space-y-2.5">
                {section.children.map((link) => (
                  <li key={link.title}>
                    <Link
                      to={link.to}
                      className="font-manrope text-sm text-gray-400 transition-colors hover:text-teal-400"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="mt-4">
          <p className="font-manrope flex flex-wrap justify-center gap-2 text-center text-xs text-gray-400">
            <Link
              to="/privacy-policy"
              className="text-gray-400 hover:text-teal-400"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-500">|</span>
            <Link
              to="/termsandconditions"
              className="text-gray-400 hover:text-teal-400"
            >
              Terms and Conditions
            </Link>
            <span className="text-gray-500">|</span>
            <span>
              © {currentYear} Mystina AI Labs Private Limited. All Rights
              Reserved. {officeAddress}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
